export default __webpack_public_path__ + "static/media/portfolio-151.ef3913bf.jpg";